const Permissions = {

    ADMINISTRATOR: 'Administrator',
    SUPPORTER: 'Supporter',
    CUSTOMER: 'Customer',
    SELLER: 'Seller'
};

export default Permissions